import React from 'react';
import './suppliers-view.css';
import '../../styles/page-common.css';
import '../../styles/list-glass.css';
import { Redirect } from "react-router-dom";
import SpinnerView from '../../components/spinner/spinner-view';
import StatementComponent from '../../components/supplierComponent';
import DownloadLink from "react-download-link";
import urls from '../../network/urls';
import { format } from '../../helpers/invoiceNumber';

const SUPPLIER_COLS = '2.2fr 1fr 0.6fr';

class SupplierView extends React.Component {

  state = {
    modal: false,
    newSupplier: {},
    showAdd: false,
    rankType: 'all',
    search: ''
  }

  componentDidMount() {
    if (this.props.selectedCompanyId) {
      this.props.dispatchGetSuppliers();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.selectedCompanyId &&
      this.props.selectedCompanyId !== prevProps.selectedCompanyId
    ) {
      this.props.dispatchGetSuppliers();
    }
  }

  updateshowAdd = (showAdd) => {
    this.setState({ showAdd })
  }

  handleSearch = (value) => {
    this.setState({ search: value });
  }

  getDataFromURL = (url, user) => new Promise((resolve, reject) => {
    setTimeout(() => {
      let req = {
        headers: { username: user.username, token: user.token, AUTHORIZATION: user.token },
        method: 'GET'
      }
      fetch(url, req)
        .then(response => response.blob())
        .then(data => { resolve(data) });
    });
  }, 2000);

  exportToCsv = (e) => {
    e.preventDefault();
    if (!this.props.suppliers || this.props.suppliers.length === 0) return;
    let headers = Object.keys(this.props.suppliers[0]);
    headers = headers.filter(i => i != 'supplierTemplateId' && i != 'userId' && i != 'companyId' && i != 'statementTemplateId');
    const downloadFile = ({ data, fileName, fileType }) => {
      const blob = new Blob([data], { type: fileType });
      const a = document.createElement('a');
      a.download = fileName;
      a.href = window.URL.createObjectURL(blob);
      a.dispatchEvent(new MouseEvent('click', { view: window, bubbles: true, cancelable: true }));
      a.remove();
    };
    downloadFile({
      data: [headers.join(';'), ...this.props.suppliers.map(t => headers.map(h => t[h]).join(';'))].join('\n'),
      fileName: 'Suppliers.csv',
      fileType: 'text/csv',
    });
  }

  render() {
    if (this.props.user && !this.props.user._id) {
      return <Redirect to='/' />
    }

    let totalU = 0;
    let rows = [];
    if (this.props.suppliers && this.props.suppliers.length > 0) {
      rows = this.props.suppliers.map(p => {
        const outstanding = parseFloat(p.outstanding) || 0;
        totalU += outstanding;
        return {
          id: p._id,
          name: (p.name + ' ' + (p.surname ?? '')).trim(),
          email: p.email || p.emailAddress || '',
          outstanding,
        };
      });
    }

    const filtered = rows
      .filter(i => {
        if (this.state.search === '') return true;
        return (i.name || '').toLowerCase().includes(this.state.search.toLowerCase());
      })
      .sort((a, b) => b.outstanding - a.outstanding);

    const groups = { owing: [], settled: [] };
    filtered.forEach(i => (i.outstanding > 0 ? groups.owing : groups.settled).push(i));
    const groupOrder = [
      { key: 'owing', label: 'Outstanding', cls: 'overdue' },
      { key: 'settled', label: 'Settled', cls: 'paid' },
    ];

    const withBalance = rows.filter(i => i.outstanding > 0).length;

    const initials = (nm) => (nm || '?').split(' ').filter(Boolean).slice(0, 2).map(w => w[0]).join('').toUpperCase();
    const avColor = (nm) => { let h = 0; for (let c = 0; c < (nm || '').length; c++) h = (h * 31 + nm.charCodeAt(c)) % 6; return h; };

    const openSupplier = (id) => {
      this.props.dispatchGetSupplier(id, (error) => { if (!error) this.updateshowAdd(true); });
    };

    return (
      <div
        className="content-wrapper p-2 accent-clients"
        style={{ ['--list-accent']: '#0891B2', ['--list-accent-dark']: '#0E7490' }}
      >
        <SpinnerView showSpinner={this.props.loading} />

        {this.state.showAdd && (
          <div style={{ padding: '0 6px' }}>
            <StatementComponent updateshowAdd={this.updateshowAdd} viewOnly={false} />
          </div>
        )}

        {/* Hero band */}
        {!this.state.showAdd && (
          <div className="gl-hero">
            <div className="gl-hero-row">
              <div>
                <div className="gl-hero-title">Suppliers</div>
                <div className="gl-hero-sub">{rows.length} supplier{rows.length === 1 ? '' : 's'} · R {format(totalU)} outstanding</div>
              </div>
              <div className="gl-hero-actions">
                <button className="gl-hero-btn" onClick={this.exportToCsv}>
                  <i className="fas fa-arrow-down"></i> Export CSV
                </button>
                <button
                  className="gl-hero-btn solid"
                  onClick={() => { this.props.dispatchSelectSupplier(undefined); this.updateshowAdd(true); }}
                >
                  <i className="fas fa-plus"></i> New supplier
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Summary band */}
        {!this.state.showAdd && (
          <div className="gl-summary">
            <div className="gl-sum-main">
              <div className="gl-sm-eyebrow">Total outstanding</div>
              <div className="gl-sm-amount-row">
                <div><span className="gl-sm-cur">R </span><span className="gl-sm-num">{format(totalU)}</span></div>
              </div>
              <div className="gl-sm-legend">
                <div className="gl-sm-leg-item">
                  <div className="gl-sm-leg-dot" style={{ background: '#fff' }}></div>
                  <div><div className="gl-sm-leg-lbl">Suppliers</div><div className="gl-sm-leg-val">{rows.length}</div></div>
                </div>
                <div className="gl-sm-leg-item">
                  <div className="gl-sm-leg-dot" style={{ background: 'rgba(255,255,255,0.45)' }}></div>
                  <div><div className="gl-sm-leg-lbl">With balance</div><div className="gl-sm-leg-val">{withBalance}</div></div>
                </div>
              </div>
            </div>

            <div className="gl-sum-side">
              <div className="gl-ss-eyebrow">Total suppliers</div>
              <div className="gl-ss-amount">{rows.length}</div>
              <div className="gl-ss-meta">on record</div>
              <span className="gl-ss-pill ok"><i className="fas fa-truck" style={{ fontSize: 8 }}></i> Active</span>
            </div>

            <div className="gl-sum-side">
              <div className="gl-ss-eyebrow">With balance</div>
              <div className="gl-ss-amount">{withBalance}</div>
              <div className="gl-ss-meta">supplier{withBalance === 1 ? '' : 's'} owing</div>
              {withBalance > 0
                ? <span className="gl-ss-pill danger"><i className="fas fa-circle" style={{ fontSize: 5 }}></i> Payable</span>
                : <span className="gl-ss-pill ok"><i className="fas fa-circle" style={{ fontSize: 5 }}></i> All settled</span>}
            </div>
          </div>
        )}

        {/* Filter bar */}
        {!this.state.showAdd && (
          <div className="gl-filter">
            <div className="gl-seg">
              <button className="gl-seg-btn active">All <span className="cnt">{rows.length}</span></button>
            </div>
            <div className="gl-search">
              <i className="fas fa-magnifying-glass"></i>
              <input placeholder="Filter suppliers…" value={this.state.search} onChange={(e) => this.handleSearch(e.target.value)} />
            </div>
          </div>
        )}

        {/* Frosted list */}
        {!this.state.showAdd && (
          <div className="gl-list" style={{ ['--gl-cols']: SUPPLIER_COLS }}>
            <div className="gl-list-head">
              <div>Supplier</div>
              <div>Outstanding</div>
              <div></div>
            </div>

            {filtered.length === 0 && (
              <div className="gl-empty">No suppliers match this view.</div>
            )}

            {groupOrder.map(g => {
              const items = groups[g.key];
              if (!items || items.length === 0) return null;
              const gsum = items.reduce((s, it) => s + (it.outstanding || 0), 0);
              return (
                <React.Fragment key={g.key}>
                  <div className="gl-group-head">
                    <span className="lbl">{g.label}</span>
                    <span className="count">{items.length}</span>
                    <span className="sum">R {format(gsum)}</span>
                  </div>
                  {items.map(it => (
                    <div key={it.id} className={`gl-row ${g.cls}`} onClick={() => openSupplier(it.id)}>
                      <div className="gl-client">
                        <div className={`gl-av gl-av-${avColor(it.name)}`}>{initials(it.name)}</div>
                        <div style={{ minWidth: 0 }}>
                          <div className="name">{it.name || '—'}</div>
                          {it.email ? <div className="sub">{it.email}</div> : null}
                        </div>
                      </div>
                      <div className={`gl-amount ${it.outstanding > 0 ? '' : 'paid'}`}>R {format(it.outstanding)}</div>
                      <div className="gl-actions" onClick={(e) => e.stopPropagation()}>
                        <button type="button" className="gl-icon-btn" onClick={() => openSupplier(it.id)}>
                          <i className="fas fa-arrow-right"></i>
                        </button>
                      </div>
                    </div>
                  ))}
                </React.Fragment>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}

export default SupplierView;
